<template>
	<v-combobox
		:id="id"
		ref="comboBoxInput"
		v-model="comboboxinput"
		:items="items"
		hide-selected
		:label="label"
		:loading="loading"
		:disabled="disabled"
		:hide-details="hideDetails"
		:deletable-chips="deletableChips"
		outlined
		:rules="rules"
		class="mt-2 pt-0"
		:prefix="prefix"
		:append-outer-icon="appendOuterIcon"
		:placeholder="placeholder"
		v-on:click:append-outer="$emit('click:append-outer', true)"
		v-on:change="$emit('change', comboboxinput)"
		:multiple="multiple"
		:chips="chips"
		:small-chips="smallChips"
	>
	</v-combobox>
</template>
<script>
export default {
	name: "combobox-input",
	model: {
		prop: "value",
		event: "input",
	},
	props: {
		value: {
			type: [Array, String],
			default: null,
		},
		items: {
			type: Array,
			required: true,
			default: () => {
				return [];
			},
		},
		rules: {
			type: [Array, Object],
			default: () => {
				return [];
			},
		},
		prefix: {
			type: String,
			default: null,
		},
		placeholder: {
			type: String,
			default: null,
		},
		id: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: null,
		},
		chips: {
			type: Boolean,
			default: false,
		},
		smallChips: {
			type: Boolean,
			default: false,
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
		deletableChips: {
			type: Boolean,
			default: false,
		},
		appendOuterIcon: {
			type: String,
			default: null,
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			comboboxinput: null,
		};
	},
	watch: {
		value() {
			this.comboboxinput = this.value;
		},
		comboboxinput() {
			this.$emit("input", this.comboboxinput);
		},
	},
	mounted() {
		this.comboboxinput = this.value;
	},
};
</script>
